<template>
    <div class="comment_title">
        <i class="sparkle_left"></i>
        <p>2026 하반기</p>
        <p>액션시민 모집 중 !!!</p>
        <i class="sparkle_right"></i>
    </div>
    <div class="complete_body">
        <div>
            <p>성매매 문제의 구조를 이해하고</p>
            <p>
                반성매매 액션에 함께 할
                <span><액션시민>을 찾습니다.</span>
            </p>
            <br />
            <p>‘반성매매 시민참여 플랫폼’ 접속 후</p>
            <p>
                <span class="info">[시민참여 활동]>[반성매매 시민활동]</span>
                에서 신청가능!!!
            </p>
        </div>
        <p>* 개인정보를 입력하신 후에 캠페인 참여가 완료됩니다.</p>
        <button id="complete_btn" @click="complete">캠페인 참여 완료하러 가기</button>
    </div>
    <div class="btns">
        <button id="prev" @click="prev">이전</button>
    </div>
    <div class="footer_bg">
        <div class="icon_wrap">
            <img src="@/assets/people2.png" alt="" />
            <img src="@/assets/people1.png" alt="" />
        </div>
    </div>
</template>

<script lang="ts">
    import { onMounted } from "@/BaseComponent";
    export default {
        emits: ["prev", "complete"],
        components: {},
        setup(props: any, { emit }: any) {
            const prev = () => {
                emit("prev");
            };
            const complete = () => {
                emit("complete");
            };

            onMounted(() => {
                window.scrollTo(0, 0);
            });
            return {
                prev,
                complete,
            };
        },
    };
</script>

<style scoped></style>
